<template>
	<div class="spbg container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<div class="row">
					<div class="col-md-12">
						<h4>OVERVIEW SPBG</h4>
					</div>
				</div>
			</div>

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12">
						<div class="row">
							<div class="col-md-6 mb-4">
								<sequential-entrance>
									<ListCompare title="SALES" unit="(Jt)" comp=1 :data="ytd.salesnominal" itemcol="Info" valuecol="Value"
										:url="''"/>
								</sequential-entrance>
							</div>
							<div class="col-md-6">
								<BarCard title="SALES WEEKLY (Jt)" :data="barchart.salesweekly" :width="500" :height="280"/>
							</div>
						</div>

						<div class="row" v-if="false">
							<!--
							<div class="col-md-6 mb-4">
								<div class="card cardptpr">
									<div class="card-header cardptpr p-3 pb-0 pt-0">
										<H6>PAYMENT YTD (B)</H6>
									</div>
									<div class="card-body p-3 pt-0" style="width:280px;">
										<PieChart :data="this.pieChartDataPayment"
											:url="'/fuel/report2?tab=2&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
									</div>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<ListCompare title="CASH PERCENTAGE" unit="%" comp=-1 :data="ytd.pctcash" itemcol="Info" valuecol="Value"
									:url="'/fuel/report2?tab=2&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
							</div>
						-->
						</div>

						<div class="row">
							<div class="col-md-6">
								<BarCard :title="'SALES ' + year + ' (Jt)'" :data="barchart.salesmonthly" :width="500" :height="400"/>
							</div>

							<div class="col-md-6">
								<ListItem class=" mb-4" title="NO OF STATIONS" :data="spbu.types" itemcol="StationType" valuecol="Cnt"
											url=""/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import {Rainbow, Config, AppColors, FuelColor, Penanggalan, AxiosWithJar } from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'

export default{
	extends: Fuel,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		//PieChart,
		//Footer
	},
	data() {
		return {
            value: 0,
			year: Penanggalan().tahun,
			pieChartDataPayment: [],
			barchart: {
				salesweekly: [],
				salesmonthly: [],
			},
			spbu:{ data:{}, list:[], types:[] },
			sales: {raw:[], hourly:[], weekly:[], monthly:[], lastTrans:[]},
			ytd: {
				raw:{}, salesvolume:[], salesnominal:[], losses:[], bbk:[], cash:[], noncash:[], pctcash:[],rekap:[],
			},
            isChildRoute: false,
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	},
	computed: {

	},

    mounted() {
        this.hideNonChildren();
		this.loadYTD();
		this.loadStationTypes();
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/spbg';
        },
		async loadYTD() {
			let url = Config().apiURL+ "/spbg/ytd?";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.ytd = {
						raw: result.data,
						salesvolume: this.processYTD(result.data.data.summary, "Info", "SalesVolume", false, "Grup", 1000, 0),
						salesnominal: this.processYTD(result.data.data.summary, "Info", "SalesNominal", false, "Grup", 1000, 0),
						//losses: this.processYTD(result.data.summary, "Info", "LossesVolume", "SalesVolume", "Grup", 0.01, 2),
						//bbk: this.processYTD(result.data.summary, "Info", "SalesVolumeBBK", "SalesVolumeAll", "Grup", 0.01, 2),
						//cash: this.processYTD(result.data.cash, "Info", "AmountCash", false, "Grup", 1, 2),
						//noncash: this.processYTD(result.data.cash, "Info", "AmountNonCash", false, "Grup", 1, 2),
						//pctcash: this.processYTD(result.data.cash, "Info", "AmountCash", "AmountAll", "Grup", 0.01, 2),
						//rekap: this.processYTD(result.data.unit, "Info", "TotalUnit", false, "Grup", 1, 2),
					};

					this.sales.weekly = result.data.data.sales_weekly;
					this.sales.monthly = result.data.data.sales_monthly;

					this.setBarchart();
				}
			})
		},

		async loadStationTypes() {
			let url = Config().apiURL + "/fuel2/station?detail=type&type=SPBG";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.types = result.data.data;
				}
			})
		},

		setBarchart() {
			this.barchart = {
				salesweekly: this.processBarChart2(this.sales.weekly, 'Legend', 'SalesNominal', false, 'Label', 1000000, 2, AppColors,
							false, false, false, true, false, false, false, true),
				salesmonthly: this.processBarChart2(this.sales.monthly, 'Legend', 'SalesNominal', false, 'Label', 1000000, 2, AppColors,
							false, false, false, true, false, false, false, true),
			}

			//console.log('this.barchart: ' + JSON.stringify(this.barchart.salesweekly));
		}
	}
}
</script>
